import { createDomain, createStore, sample } from 'effector'
import { createGate } from 'effector-react'
import { CmsBlock } from '~/shared/api'
import { RentalServiceCmsBlock } from '~/shared/config/enums'
import { logger } from '~/shared/lib/logger'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('entities.rentalService.ui.more.moreDrawer')

export const Gate = createGate()

export const getCmsBlock = domain.createEvent()
export const getCmsBlockFx = domain.createEffect({
  async handler() {
    const response = await CmsBlock.where(
      'position',
      RentalServiceCmsBlock.RENTAL_SERVICES_MORE_DRAWER,
    ).first()

    return response.getData()
  },
})

export const $cmsBlock = createStore<CmsBlock | null>(null)
  .on(getCmsBlockFx.doneData, (_, cmsBlock) => cmsBlock)
  .on(getCmsBlockFx.failData, () => null)

sample({
  clock: Gate.open,
  source: $cmsBlock,
  filter: (cmsBlock) => !cmsBlock,
  target: getCmsBlock,
})

sample({
  clock: getCmsBlock,
  target: getCmsBlockFx,
})

sample({
  clock: getCmsBlockFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: 'Ошибка получения описания услуг',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
